const doc = [({"se":({"js":({"components":({"admin":({"layout":({"menu":({"sign_out":"Logga ut", "you_have_been_signed_out":"Du har blivit utloggad."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;